import { runtimeApiBaseUrl } from "./runtimeConfig";

export function apiBaseUrl(): string {
  const url = runtimeApiBaseUrl() ?? import.meta.env.VITE_API_BASE_URL;
  if (!url) return "";
  return new URL(url).href.replace(/\/+$/, "");
}

function pageOrigin(): string | undefined {
  return typeof location === "undefined" ? undefined : location.origin;
}

export function apiUrl(path: string): URL {
  return new URL(apiBaseUrl() + path, pageOrigin());
}
